import { useEffect, useState } from "react";
import axios from "axios";

import { getRoles } from "../api/adminApi";

const API = "http://localhost:5001/api";

const RolesPage = () => {

  const [roles, setRoles] = useState([]);

  useEffect(() => {
  getRoles()
    .then(res => setRoles(res.data))
    .catch(console.error);
}, []);

  const loadRoles = async () => {
    try {
      const res = await axios.get(`${API}/admin/roles`);
      setRoles(res.data || []);
    } catch (err) {
      console.error("Roles load failed", err);
    }
  };

  useEffect(() => {
    loadRoles();
  }, []);

  return (
    <div className="space-y-6">

      <div className="flex justify-between">
        <h2 className="text-xl font-black">Roles</h2>

        <button className="bg-blue-950 text-white px-4 py-2 rounded-lg font-semibold">
          + Create Role
        </button>
      </div>

      <div className="bg-white rounded-xl border p-4 space-y-3">

        {roles.map(role => (
          <div
            key={role.RoleID}
            className="flex justify-between items-center border rounded-lg p-4 hover:bg-slate-50"
          >
            <div>
              <p className="font-bold">{role.RoleName}</p>
              <p className="text-sm text-slate-400">
                {role.Description}
              </p>
            </div>

            <button className="text-blue-950 font-semibold">
              Configure
            </button>
          </div>
        ))}

      </div>
    </div>
  );
};

export default RolesPage;